var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#878787;}\n\t.st1{fill:#9E9E9E;}\n\t.st2{fill:#BBBBBB;}\n\t.st3{fill:#A3A3A3;}\n\t.st4{fill:#4285F4;}\n\t.st5{fill:#34A853;}\n\t.st6{fill:#FBBC05;}\n\t.st7{fill:#EB4335;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,24.5c0-1.9-0.2-3.3-0.5-4.7H24.5v8.5h12.7c-0.3,2.1-1.6,5.3-4.7,7.5l0,0.3l6.8,5.3l0.5,0 C44.1,37.4,46.6,31.5,46.6,24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,47c6.2,0,11.4-2,15.2-5.6l-7.3-5.6c-1.9,1.4-4.6,2.3-8,2.3c-6.1,0-11.3-4-13.1-9.6l-0.3,0L4,34.1 l-0.1,0.3C7.7,41.9,15.5,47,24.5,47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.4,28.6c-0.5-1.4-0.8-3-0.8-4.6c0-1.6,0.3-3.1,0.7-4.6l0-0.3l-7.2-5.6l-0.2,0.1C2.3,16.8,1.4,20.3,1.4,24 s0.9,7.2,2.5,10.3L11.4,28.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.5,9.9c4.3,0,7.2,1.9,8.9,3.4L39.9,7c-4-3.7-9.2-6-15.4-6c-9,0-16.8,5.2-20.6,12.7l7.4,5.8 C13.2,13.9,18.4,9.9,24.5,9.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.6,24.5c0-1.9-0.2-3.3-0.5-4.7H24.5v8.5h12.7c-0.3,2.1-1.6,5.3-4.7,7.5l0,0.3l6.8,5.3l0.5,0 C44.1,37.4,46.6,31.5,46.6,24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.5,47c6.2,0,11.4-2,15.2-5.6l-7.3-5.6c-1.9,1.4-4.6,2.3-8,2.3c-6.1,0-11.3-4-13.1-9.6l-0.3,0L4,34.1 l-0.1,0.3C7.7,41.9,15.5,47,24.5,47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M11.4,28.6c-0.5-1.4-0.8-3-0.8-4.6c0-1.6,0.3-3.1,0.7-4.6l0-0.3l-7.2-5.6l-0.2,0.1C2.3,16.8,1.4,20.3,1.4,24 s0.9,7.2,2.5,10.3L11.4,28.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.5,9.9c4.3,0,7.2,1.9,8.9,3.4L39.9,7c-4-3.7-9.2-6-15.4-6c-9,0-16.8,5.2-20.6,12.7l7.4,5.8 C13.2,13.9,18.4,9.9,24.5,9.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.4ff97995468ff946baa17105b13d3246.svg";
export { ForwardRef as ReactComponent };